<div
  class="card modern-card full-width"
>
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Account Management</h1>
      </div>
    </div>
  </div>

  <div class="card-body px-4 pb-4">
    <div class="row w-100 m-0">
      <!-- Left Side: Form -->
      <div class="col-xl-8 col-lg-7 account-form-column">
        <form
          [formGroup]="this.accountForm"
          class="d-flex flex-column mb-4"
          style="gap: 15px"
        >
          <!-- FFL, FFL Expiration -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="ffl">FFL:</label>
            <div class="d-flex align-items-center gap-2 flex-grow-1 flex-nowrap">
              <div class="position-relative w-ffl">
                <input
                  type="text"
                  class="form-control text-uppercase w-100"
                  formControlName="ffl"
                  id="ffl"
                  [placeholder]="'_-__-___-__-__-_____'"
                  [dropSpecialCharacters]="false"
                  mask="0-00-000-00-0A-00000"
                  (input)="verifyFFL()"
                  [style.padding-right]="(fflValidated || fflInvalid) ? '30px' : ''"
                />
                @if (fflValidated) {
                <i class="fa-solid fa-check-circle text-success position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%); font-size: 1.1rem;"></i>
                }
                @if (fflInvalid) {
                <i class="fa-solid fa-circle-xmark text-danger position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%); font-size: 1.1rem;"></i>
                }
              </div>
              <label class="sub-label mb-0" for="ffl_expiration_date"
                >FFL Expiration:</label
              >
              <input
                class="form-control flex-grow-1"
                type="text"
                id="ffl_expiration_date"
                formControlName="ffl_expiration_date"
              />
            </div>
          </div>

          <!-- Company Name -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="company_name"
              >Company Name (DBA):</label
            >
            <input
              class="form-control flex-grow-1"
              type="text"
              id="company_name"
              formControlName="company_name"
            />
          </div>

          <!-- Legal Name -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="legal_name">Legal Name:</label>
            <input
              class="form-control flex-grow-1"
              type="text"
              id="legal_name"
              formControlName="legal_name"
            />
          </div>

          <!-- EIN -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="ein">EIN:</label>
            <input
              class="form-control w-short"
              type="text"
              id="ein"
              formControlName="ein"
            />
          </div>

          <!-- Address -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="address">Address:</label>
            <input
              class="form-control flex-grow-1"
              type="text"
              id="address"
              formControlName="address"
            />
          </div>

          <!-- Address 2 -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="address2">Address 2:</label>
            <input
              class="form-control flex-grow-1"
              type="text"
              id="address2"
              formControlName="address2"
            />
          </div>

          <!-- Zip Code, City, State -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="zip_code">Zip Code:</label>
            <div class="d-flex align-items-center gap-2 flex-grow-1 flex-nowrap">
              <input
                class="form-control w-zip"
                type="text"
                id="zip_code"
                formControlName="zip_code"
              />
              <label class="sub-label mb-0" for="city">City:</label>
              <input
                class="form-control flex-grow-1"
                type="text"
                id="city"
                formControlName="city"
              />
              <label class="sub-label mb-0" for="state">State:</label>
              <input
                class="form-control w-state"
                type="text"
                id="state"
                formControlName="state"
              />
            </div>
          </div>

          <!-- Phone Number -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="phone_number">Phone Number:</label>
            <input
              class="form-control w-short"
              type="text"
              id="phone_number"
              formControlName="phone_number"
            />
          </div>

          <!-- Company Email -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="company_email">Company Email:</label>
            <input
              class="form-control flex-grow-1"
              type="text"
              id="company_email"
              formControlName="company_email"
            />
          </div>

          <!-- Customer Facing Email -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="customer_facing_email"
              >Customer Facing Email:</label
            >
            <input
              class="form-control flex-grow-1"
              type="text"
              id="customer_facing_email"
              formControlName="customer_facing_email"
            />
          </div>

          <!-- Company Website -->
          <div class="form-group d-flex align-items-center mb-0">
            <label class="main-label" for="website">Company Website:</label>
            <input
              class="form-control flex-grow-1"
              type="text"
              id="website"
              formControlName="website"
            />
          </div>

          <div class="row m-0 mt-3 justify-content-end w-100">
            <div class="main-label" style="width: 150px"></div>
            <button
              class="btn green-btn flex-shrink-0"
              style="width: 150px"
              [disabled]="!accountForm.valid && !accountForm.touched"
              (click)="saveAccountInfo()"
            >
              <i class="fa fa-save me-2"></i>Save
            </button>
          </div>
        </form>
      </div>

      <!-- Right Side: Doc Cards -->
      <div class="col-xl-4 col-lg-5 account-docs-column">
        <div
          class="d-flex flex-column gap-3 w-100 align-items-center mt-3 mt-lg-0 pb-4"
        >
          <!-- Company Logo Card -->
          <div class="doc-card bg-dark-subtle text-dark border-secondary" [class.frosted]="uploadingLogo || removingLogo">
            @if (uploadingLogo || removingLogo) {
              <div class="frost-overlay">
                <div class="frost-spinner"></div>
                <span>{{ uploadingLogo ? 'Uploading...' : 'Removing...' }}</span>
              </div>
            }
            <div class="doc-card-header text-dark border-bottom border-secondary">
              <label class="card-title-text text-dark">Company Logo (PNG)</label>
              @if (sharedService.company_info.company_logo) {
                <div class="btn-group btn-group-sm" role="group" aria-label="Logo actions">
                  <button
                    type="button"
                    class="btn modern-btn grey-btn btn-sm"
                    (click)="replaceLogo()"
                    title="Replace Logo"
                  >
                    <i class="fa fa-upload me-2"></i> Replace
                  </button>
                  <button
                    type="button"
                    class="btn modern-btn btn-danger btn-sm"
                    (click)="removeExistingLogo()"
                    title="Remove Logo"
                  >
                    <i class="fa fa-trash me-2"></i> Remove
                  </button>
                </div>
              }
            </div>

            @if (sharedService.company_info.company_logo) {
              <div class="logo-preview-card mt-2">
                <span class="preview-badge">PREVIEW</span>
                <div class="logo-preview-body">
                  <div class="logo-thumb">
                    <img
                      [src]="companyLogoUrl || sharedService.company_info.company_logo"
                      alt="Company Logo"
                      class="logo-image"
                    />
                  </div>
                  <div class="logo-info">
                    <div class="file-name">
                      {{ logoFileName || 'Logo.png' }}
                    </div>
                    <div class="file-meta-row">
                      <span class="file-type-badge">PNG</span>
                      <span class="file-size">{{ formatFileSize(logoFileSize) }}</span>
                    </div>
                    <div class="file-status">
                      <i class="fa-solid fa-circle-check"></i>
                      @if (logoUploadedAt) {
                        Uploaded {{ timeAgo(logoUploadedAt) }}
                      } @else {
                        On file
                      }
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div class="dropzone-flex mt-2">
                <ngx-dropzone
                  (change)="addLogo($event)"
                  [maxFileSize]="20000000"
                  [multiple]="false"
                  style="flex: 1; height: 120px"
                  class="custom-dropzone"
                >
                  <ngx-dropzone-label>
                    <div class="dropzone-state" [hidden]="uploadingLogo || removingLogo">
                      <i class="fa-solid fa-cloud-arrow-up dropzone-icon"></i>
                      <span class="dropzone-prompt">Drop your file</span>
                      <span class="dropzone-hint">PNG — up to 20 MB</span>
                    </div>
                  </ngx-dropzone-label>

                  @for (file of logo; track file) {
                    <ngx-dropzone-preview
                      [removable]="true"
                      (removed)="removeLogo()"
                    >
                      <ngx-dropzone-label>{{ file.name }}</ngx-dropzone-label>
                    </ngx-dropzone-preview>
                  }
                </ngx-dropzone>
              </div>
            }
          </div>

          <!-- FFL Document Card -->
          <div class="doc-card bg-dark-subtle text-dark border-secondary" [class.frosted]="uploadingFfl || removingFfl">
            @if (uploadingFfl || removingFfl) {
              <div class="frost-overlay">
                <div class="frost-spinner"></div>
                <span>{{ uploadingFfl ? 'Uploading...' : 'Removing...' }}</span>
              </div>
            }
            <div class="doc-card-header text-dark border-bottom border-secondary">
              <label class="card-title-text text-dark">FFL Document (PDF)</label>
              @if (sharedService.company_info.ffl_document) {
                <div class="btn-group btn-group-sm" role="group" aria-label="FFL Document actions">
                  <button
                    type="button"
                    class="btn modern-btn grey-btn btn-sm"
                    (click)="viewDocument(sharedService.company_info.ffl_document)"
                    title="View FFL"
                  >
                    <i class="fa fa-eye me-2"></i> View
                  </button>
                  <button
                    type="button"
                    class="btn modern-btn grey-btn btn-sm"
                    (click)="replaceDocument('ffl')"
                    title="Replace FFL"
                  >
                    <i class="fa fa-upload me-2"></i> Replace
                  </button>
                  <button
                    type="button"
                    class="btn modern-btn btn-danger btn-sm"
                    (click)="removeFflDocument()"
                    title="Remove FFL"
                  >
                    <i class="fa fa-trash me-2"></i> Remove
                  </button>
                </div>
              }
            </div>
            @if (sharedService.company_info.ffl_document) {
              <div class="file-preview-card mt-2">
                <span class="preview-badge">PREVIEW</span>
                <div class="file-preview-body">
                  <div class="file-thumb">
                    <i class="fa-solid fa-file-pdf text-muted"></i>
                  </div>
                  <div class="file-info">
                    <div class="file-name">
                      {{ sharedService.company_info.ffl_document_meta?.file_name || 'FFL.pdf' }}
                    </div>
                    <div class="file-meta-row">
                      <span class="file-type-badge">PDF</span>
                      <span class="file-size">{{ formatFileSize(sharedService.company_info.ffl_document_meta?.file_size_kb) }}</span>
                    </div>
                    <div class="file-status">
                      <i class="fa-solid fa-circle-check"></i>
                      @if (sharedService.company_info.ffl_document_meta?.uploaded_at) {
                        Uploaded {{ timeAgo(sharedService.company_info.ffl_document_meta?.uploaded_at) }}
                      } @else {
                        On file
                      }
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div class="dropzone-flex mt-2">
                <ngx-dropzone
                  (change)="addFflDocument($event)"
                  [maxFileSize]="20000000"
                  [multiple]="false"
                  style="flex: 1; height: 120px"
                  accept="application/pdf"
                  class="custom-dropzone"
                >
                  <ngx-dropzone-label>
                    <div class="dropzone-state" [hidden]="uploadingFfl || removingFfl">
                      <i class="fa-solid fa-cloud-arrow-up dropzone-icon"></i>
                      <span class="dropzone-prompt">Drop your file</span>
                      <span class="dropzone-hint">PDF — up to 20 MB</span>
                    </div>
                  </ngx-dropzone-label>
                </ngx-dropzone>
              </div>
            }
          </div>

          <!-- SOT Document Card -->
          <div class="doc-card bg-dark-subtle text-dark border-secondary" [class.frosted]="uploadingSot || removingSot">
            @if (uploadingSot || removingSot) {
              <div class="frost-overlay">
                <div class="frost-spinner"></div>
                <span>{{ uploadingSot ? 'Uploading...' : 'Removing...' }}</span>
              </div>
            }
            <div class="doc-card-header text-dark border-bottom border-secondary">
              <label class="card-title-text text-dark">SOT Document (PDF)</label>
              @if (sharedService.company_info.sot_document) {
                <div class="btn-group btn-group-sm" role="group" aria-label="SOT Document actions">
                  <button
                    type="button"
                    class="btn modern-btn grey-btn btn-sm"
                    (click)="viewDocument(sharedService.company_info.sot_document)"
                    title="View SOT"
                  >
                    <i class="fa fa-eye me-2"></i> View
                  </button>
                  <button
                    type="button"
                    class="btn modern-btn grey-btn btn-sm"
                    (click)="replaceDocument('sot')"
                    title="Replace SOT"
                  >
                    <i class="fa fa-upload me-2"></i> Replace
                  </button>
                  <button
                    type="button"
                    class="btn modern-btn btn-danger btn-sm"
                    (click)="removeSotDocument()"
                    title="Remove SOT"
                  >
                    <i class="fa fa-trash me-2"></i> Remove
                  </button>
                </div>
              }
            </div>
            @if (sharedService.company_info.sot_document) {
              <div class="file-preview-card mt-2">
                <span class="preview-badge">PREVIEW</span>
                <div class="file-preview-body">
                  <div class="file-thumb">
                    <i class="fa-solid fa-file-pdf text-muted"></i>
                  </div>
                  <div class="file-info">
                    <div class="file-name">
                      {{ sharedService.company_info.sot_document_meta?.file_name || 'SOT.pdf' }}
                    </div>
                    <div class="file-meta-row">
                      <span class="file-type-badge">PDF</span>
                      <span class="file-size">{{ formatFileSize(sharedService.company_info.sot_document_meta?.file_size_kb) }}</span>
                    </div>
                    <div class="file-status">
                      <i class="fa-solid fa-circle-check"></i>
                      @if (sharedService.company_info.sot_document_meta?.uploaded_at) {
                        Uploaded {{ timeAgo(sharedService.company_info.sot_document_meta?.uploaded_at) }}
                      } @else {
                        On file
                      }
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div class="dropzone-flex mt-2">
                <ngx-dropzone
                  (change)="addSotDocument($event)"
                  [maxFileSize]="20000000"
                  [multiple]="false"
                  style="flex: 1; height: 120px"
                  accept="application/pdf"
                  class="custom-dropzone"
                >
                  <ngx-dropzone-label>
                    <div class="dropzone-state" [hidden]="uploadingSot || removingSot">
                      <i class="fa-solid fa-cloud-arrow-up dropzone-icon"></i>
                      <span class="dropzone-prompt">Drop your file</span>
                      <span class="dropzone-hint">PDF — up to 20 MB</span>
                    </div>
                  </ngx-dropzone-label>
                </ngx-dropzone>


              </div>
            }
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>
